import { Inject, Injectable, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { plainToClass } from 'class-transformer';
import { DecimalPipe } from '@angular/common';
import { EventService } from '@services/event/event.service';
import { EntityService } from '@services/entity/entity.service';
import { Tag } from '@models/tag';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TagsService extends EntityService {

  public entityRoute = "tags";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  getTagsOfCustomer(customerId: number): Observable<Tag[]> {
    return this.http.get<Tag[]>(this.baseUrl + 'api/Tags/' + customerId);
  }

  static matches(tag: Tag, term: string, pipe?: PipeTransform) {
    return tag.name.toLowerCase().includes(term);
  }
}
